// src/redux/slices/requestSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  controller: null,
};

const requestSlice = createSlice({
  name: 'request',
  initialState,
  reducers: {
    createController(state) {
      if (state.controller) {
        try {
          state.controller.abort();
        } catch {}
      }
      state.controller = new AbortController();
    },
    abortAll(state) {
      if (state.controller) {
        try {
          state.controller.abort();
        } catch {}
      }
      state.controller = null;
    },
  },
});

export const { createController, abortAll } = requestSlice.actions;
export default requestSlice.reducer;
